import type { RouteRecordRaw } from 'vue-router';
import {
  ReminderGeneralHistoryPage,
  ReminderHistoryPage,
  ReminderMyHistoryPage,
} from '@/pages/reminder-history';

export const routeName = 'HistoricoAvisos';

export const route: RouteRecordRaw = {
  path: 'historico-avisos',
  name: routeName,
  component: ReminderHistoryPage,
  redirect: { name: 'HistoricoAvisosMeu' },
  meta: {
    requiresAuth: true,
    breadcrumb: 'Histórico de Avisos',
  },
  children: [
    {
      path: 'meu-historico',
      name: 'HistoricoAvisosMeu',
      component: ReminderMyHistoryPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Meu Histórico',
      },
    },
    {
      path: 'historico-geral',
      name: 'HistoricoAvisosGeral',
      component: ReminderGeneralHistoryPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Histórico Geral',
        permissions: [{ action: 'readGeneral', subject: 'NoticeHistory' }],
      },
    },
  ],
};
